module.exports = __webpack_public_path__ + "img/advantage5.6973f625.png";